import React, { useEffect, useMemo, useState } from "react";
import { FontColor, FourGround } from "../../assets/js/theme";
import Sidebar from "../../components/admin/sidebar/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import {
  getAdminIspOwnersComments,
  getComments,
  getIspOwners,
} from "../../features/apiCallAdmin";
import moment from "moment";
import Table from "../../components/table/Table";
import {
  ArrowClockwise,
  FileExcelFill,
  FilterCircle,
  PenFill,
  PersonFill,
  ThreeDots,
} from "react-bootstrap-icons";
import useDash from "../../assets/css/dash.module.css";
import "./allComments.css";
import DetailsModal from "./modal/DetailsModal";
import EditModal from "./modal/EditModal";
import { badge } from "../../components/common/Utils";
import Note from "../Home/modal/Note";
import { CSVLink } from "react-csv";
import PaginatedTable from "../../components/table/PaginatedTable";
import Loader from "../../components/common/Loader";
import { Accordion } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import useDataState from "../../hooks/useDataState";
import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";

const AllComments = () => {
  const { t } = useTranslation();

  const { filterOptions, setFilterOption } = useDataState();

  // loading state
  const [isLoading, setIsLoading] = useState(false);
  const [ispOwnerLoading, setIspOwnerLoading] = useState(false);

  // initial customer id state
  const [commentID, setCommentID] = useState("");

  // initial owner Id state
  const [ownerId, setOwnerId] = useState();

  // initial company name state
  const [companyName, setCompanyName] = useState();

  //filter state
  const [type, setType] = useState("");
  const [status, setStatus] = useState("");

  // import dispatch
  const dispatch = useDispatch();

  // get all note in redux
  let comments = useSelector((state) => state.admin?.comments);

  const [ispOwnersComments, setIspOwnersComment] = useState({
    data: [],
    totalPages: 0,
  });
  const [activeKeys, setActiveKeys] = useState("");

  const searchParams = new URLSearchParams({
    page: 1,
    limit: 50,
  }).toString();

  // get note api call
  useEffect(() => {
    getAdminIspOwnersComments(dispatch, setIsLoading, searchParams);
  }, []);

  useEffect(() => {
    if (comments) {
      setIspOwnersComment((prev) => {
        return {
          data: comments?.data ?? [],
          page: comments?.page ?? 1,
          limit: comments?.limit ?? 100,
          total: comments?.total ?? prev?.total ?? 0,
          totalPages: comments?.totalPages ?? prev?.totalPages ?? 0,
          nextCursor: comments?.nextCursor ?? null,
          previousCursor: comments?.previousCursor ?? null,
        };
      });
    }
  }, [comments]);

  const reloadHandler = () => {
    getAdminIspOwnersComments(dispatch, setIsLoading, searchParams);
  };

  // get all company name from redux
  const company = useSelector((state) => state?.companyName?.ispOwnerIds);

  // handle delete
  const detailsModal = (commentId) => {
    setCommentID(commentId);
    // console.log(commentId);
  };

  // handle edit
  const handleEdit = (commentId) => {
    setCommentID(commentId);
  };

  const showIndividualComment = (ispOwnerId, companyName) => {
    setOwnerId(ispOwnerId);
    setCompanyName(companyName);
  };

  const filterInputs = [
    {
      name: "startCreateDate",
      type: "date",
      id: "startCreateDate",
      isVisible: true,
      disabled: false,
      placeholderText: t("startCreateDate"),
      component: "DatePicker",
      dateFormat: "yyyy MM dd hh:mm a",
      timeIntervals: 1,
      showTimeSelect: "showTimeSelect",
      selected: filterOptions?.startCreateDate,
      onChange: (date) => {
        setFilterOption({
          ...filterOptions,
          startCreateDate: date,
        });
      },
    },
    {
      name: "endCreateDate",
      type: "date",
      id: "endCreateDate",
      isVisible: true,
      disabled: false,
      placeholderText: t("endCreateDate"),
      component: "DatePicker",
      dateFormat: "yyyy MM dd hh:mm a",
      timeIntervals: 1,
      showTimeSelect: "showTimeSelect",
      selected: filterOptions?.endCreateDate,
      onChange: (date) => {
        setFilterOption({
          ...filterOptions,
          endCreateDate: date,
        });
      },
    },
    {
      name: "commentType",
      type: "select",
      id: "commentType",
      value: filterOptions.commentType,
      isVisible: true,
      disabled: false,
      onChange: (e) => {
        setFilterOption({
          ...filterOptions,
          commentType: e.target.value,
        });
      },
      options: [
        {
          text: "Support",
          value: "support",
        },
        {
          text: "Feature",
          value: "feature",
        },
        {
          text: "Migration",
          value: "migration",
        },
      ],
      firstOptions: "Type",
      textAccessor: "text",
      valueAccessor: "value",
    },
    {
      name: "status",
      type: "select",
      id: "status",
      value: filterOptions.status,
      isVisible: true,
      disabled: false,
      onChange: (e) => {
        setFilterOption({
          ...filterOptions,
          status: e.target.value,
        });
      },
      options: [
        {
          text: "Pending",
          value: "pending",
        },
        {
          text: "Processing",
          value: "processing",
        },
        {
          text: "Completed",
          value: "completed",
        },
      ],
      firstOptions: "Status",
      textAccessor: "text",
      valueAccessor: "value",
    },
  ];

  // table column
  const columns = useMemo(
    () => [
      {
        width: "6%",
        Header: "ID",
        accessor: "ispOwner.netFeeId",
      },

      {
        width: "12%",
        Header: "Name",
        accessor: "name",
      },
      {
        width: "12%",
        Header: "Company",
        accessor: "ispOwner.company",
      },
      {
        width: "10%",
        Header: "Type",
        accessor: "commentType",
        Cell: ({ cell: { value } }) => {
          return (
            <div>
              <span>{badge(value)}</span>
            </div>
          );
        },
      },
      {
        width: "8%",
        Header: "Status",
        accessor: "status",
        Cell: ({ cell: { value } }) => {
          return (
            <div>
              <span>{badge(value)}</span>
            </div>
          );
        },
      },
      {
        width: "28%",
        Header: "Comment",
        Cell: ({ row: { original } }) => {
          return (
            <div>
              {original.comment && original.comment.slice(0, 50)}
              <span
                className="text-primary see-more"
                data-bs-toggle="modal"
                data-bs-target="#detailsComment"
                onClick={() => {
                  detailsModal(original);
                }}
              >
                {" "}
                {original.comment && "...see more"}
              </span>
            </div>
          );
        },
      },

      {
        width: "12%",
        Header: "CreatedAt",
        accessor: "createdAt",
        Cell: ({ cell: { value } }) => {
          return moment(value).format("DD MMM YY hh:mm a");
        },
      },

      {
        width: "8%",
        Header: () => <div className="text-center">Action</div>,
        id: "option",

        Cell: ({ row: { original } }) => (
          <div className="text-center">
            <>
              <ThreeDots
                className="dropdown-toggle ActionDots"
                id="areaDropdown"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              />
              <ul className="dropdown-menu" aria-labelledby="areaDropdown">
                <li
                  data-bs-toggle="modal"
                  data-bs-target="#detailsComment"
                  onClick={() => {
                    detailsModal(original);
                  }}
                >
                  <div className="dropdown-item">
                    <div className="customerAction">
                      <PersonFill />
                      <p className="actionP">Details</p>
                    </div>
                  </div>
                </li>

                <li
                  data-bs-toggle="modal"
                  data-bs-target="#editComment"
                  onClick={() => {
                    handleEdit(original);
                  }}
                >
                  <div className="dropdown-item">
                    <div className="customerAction">
                      <PenFill />
                      <p className="actionP">Edit</p>
                    </div>
                  </div>
                </li>
              </ul>
            </>
          </div>
        ),
      },
    ],
    [company],
  );

  const handleTableQuerySubmition = (query, setTableLoading) => {
    const {
      page = comments?.page,
      limit = comments?.limit,
      nextCursor,
      previousCursor,
      search,
    } = query;

    const {
      status,
      monthlyPaymentStatus,
      executeBillingCycle,
      queueType,
      customerType,
      hasMikrotik,
      hasOLT,
      district,
      startCreateDate,
      endCreateDate,
      startBillDate,
      endBillDate,
    } = filterOptions;

    const buieldQuery = {
      page,
      limit,
      nextCursor,
      previousCursor,
      search,
      status,
      monthlyPaymentStatus,
      executeBillingCycle,
      queueType,
      customerType,
      hasMikrotik,
      hasOLT,
      district,
      startCreateDate,
      endCreateDate,
      startBillDate,
      endBillDate,
    };

    const searchParams = new URLSearchParams(
      Object.entries(buieldQuery).filter(
        ([_, value]) => value !== undefined && value !== null && value !== "",
      ),
    ).toString();

    const loading = setTableLoading ? setTableLoading : setIsLoading;

    getAdminIspOwnersComments(dispatch, loading, searchParams);
  };

  const handleTableFilterdQuerySubmition = (query) => {
    const { startCreateDate, endCreateDate, commentType, status } = query;

    const buieldQuery = {
      page: 1,
      limit: 50,
      startCreateDate,
      endCreateDate,
      commentType,
      status,
    };

    const searchParams = new URLSearchParams(
      Object.entries(buieldQuery).filter(
        ([_, value]) => value !== undefined && value !== null && value !== "",
      ),
    ).toString();

    getAdminIspOwnersComments(dispatch, setIsLoading, searchParams);
  };

  const handleFilterReset = () => {
    if (Object.keys(filterOptions).length > 0) {
      const resetFilterOptions = Object.fromEntries(
        filterInputs.map((input) => [input.name, ""]),
      );

      setFilterOption(resetFilterOptions);

      handleTableFilterdQuerySubmition(resetFilterOptions);
    }
  };

  return (
    <>
      <Sidebar />
      <ToastContainer position="top-right" theme="colored" />

      <div className={useDash.dashboardWrapper}>
        <div className="container-fluied collector">
          <div className="container">
            <FontColor>
              <FourGround>
                <div className="collectorTitle d-flex justify-content-between px-4">
                  <div className="component_name">Comments</div>

                  <div className="d-flex align-items-center">
                    <div
                      onClick={() => {
                        if (!activeKeys) {
                          setActiveKeys("filter");
                        } else {
                          setActiveKeys("");
                        }
                      }}
                      title="Filter"
                    >
                      <FilterCircle className="addcutmButton" />
                    </div>

                    <div className="reloadBtn">
                      {isLoading ? (
                        <Loader />
                      ) : (
                        <ArrowClockwise
                          className="arrowClock"
                          title="Refresh"
                          onClick={reloadHandler}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </FourGround>

              <FourGround>
                <div className="mt-2">
                  <Accordion alwaysOpen activeKey={activeKeys}>
                    <Accordion.Item eventKey="filter">
                      <Accordion.Body>
                        <div className="displayGrid6">
                          {filterInputs.map((item) => {
                            if (item.isVisible) {
                              return item.type === "select" ? (
                                <select
                                  className="form-select shadow-none mt-0"
                                  onChange={item.onChange}
                                  value={item.value}
                                >
                                  <option value="">{item.firstOptions}</option>
                                  {item.options?.map((opt) => (
                                    <option value={opt[item.valueAccessor]}>
                                      {opt[item.textAccessor]}
                                    </option>
                                  ))}
                                </select>
                              ) : (
                                <div>
                                  <DatePicker
                                    className="form-control mt-0"
                                    {...item}
                                  />
                                </div>
                              );
                            }
                          })}

                          <div className="displayGrid1">
                            <button
                              className="btn btn-outline-primary"
                              type="button"
                              onClick={() =>
                                handleTableFilterdQuerySubmition(filterOptions)
                              }
                            >
                              {t("filter")}
                            </button>
                            <button
                              className="btn btn-outline-secondary"
                              type="button"
                              onClick={handleFilterReset}
                            >
                              {t("reset")}
                            </button>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  <div className="collectorWrapper pb-2">
                    <PaginatedTable
                      isLoading={isLoading}
                      columns={columns}
                      data={ispOwnersComments}
                      callTableQueryApi={handleTableQuerySubmition}
                    />
                  </div>
                </div>
              </FourGround>
            </FontColor>
          </div>
        </div>
      </div>

      <Note ownerId={ownerId} companyName={companyName} />
      <DetailsModal message={commentID} isLoading={isLoading} />
      <EditModal message={commentID} />
    </>
  );
};

export default AllComments;
